import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ActionstepAuthResponse, AuthResponse, UserDetails } from '../models/user-details';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppConfiguration } from '../models/app-configuration';
import { RequestsService } from './requests.service';
import { JwtToken } from '../models/jwt-token';
import { JwtHelperService } from './jwt-helper.service';
import { Jurisdiction } from '../models/jurisdiction';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    userSubjectChanged: Subject<UserDetails | null> = new Subject<UserDetails | null>();

    userDetails: UserDetails | undefined;

    lineTimeUserEmail: string = "";

    isAutherized: boolean | undefined;

    private hasAccessToViewLogsSource = new BehaviorSubject<boolean>(false);
    hasAccessToViewLogs$ = this.hasAccessToViewLogsSource.asObservable();

    setHasAccessToViewLogs(value: boolean) {
        this.hasAccessToViewLogsSource.next(value);
    }
    url = "api/p4w/security";
    actionStepAuthorizeUrl = `${this.commonService.appConfig?.apiEndpoint}/api/oauth/authorize?response_type=code&scope=${this.commonService.appConfig?.scope}&client_id=${this.commonService.appConfig?.clientId}&redirect_uri=${this.commonService.appConfig?.redirectUri}`;
    actionStepTokenUrl = "https://api.actionstepstaging.com/api/oauth/token";

    constructor(
        private dataService: DataService,
        private router: Router,
        private commonService: CommonService,
        private requestService: RequestsService,
        private http: HttpClient,
        private jwtService: JwtHelperService
    ) { }

    async getUser(): Promise<UserDetails> {
        return await this.dataService.get<UserDetails>(this.url);
    }

    async getCurrentUserRole(): Promise<string> {
        return await this.dataService.get<string>("api/users/current-user-role");
    }

    async windowsLogin(email?: string): Promise<AuthResponse> {
        return new Promise(
            (resolve, reject) => {
                let loginUrl = `api/users/auth-user`
                var urlSplit = window.location.href.split("/")

                if (urlSplit.length == 4 && window.location.href.includes("?code=")) {
                    var authCode = window.location.href.substr(window.location.href.indexOf("?code=") + 6)
                    this.dataService.post<string>(loginUrl, {
                        userEmail: email ?? "",
                        authCode: authCode ?? "",
                        redirectUrl: this.commonService.appConfig?.redirectUri ?? "",
                        grantType: "token",
                        refreshToken: ""
                    })
                        .then(async (d: any) => {
                            localStorage.setItem("tenantId", this.commonService.encrypt(d.orgkey));
                            localStorage.setItem("refresh-token", this.commonService.encrypt(d.refresh_token));
                            localStorage.setItem("token", this.commonService.encrypt(d.access_token!));

                            let LoggedUserRole = await this.getCurrentUserRole();

                            let userData: JwtToken | undefined = this.jwtService.decodeToken(d.access_token!);
                            if (userData) {
                                let fullName = userData.name;

                                if (fullName.indexOf(",") >= 0) {
                                    fullName = (fullName.indexOf(",") >= 0 ? fullName.substring(fullName.indexOf(",") + 1) + " " + fullName.substring(0, fullName.indexOf(",")) : fullName).trim();
                                }

                                const names = fullName.trim().split(" ");
                                const initials = names[0].charAt(0)?.toUpperCase() + names[names.length - 1].charAt(0)?.toUpperCase();

                                this.userDetails = {
                                    code: userData.sub,
                                    fullName: fullName,
                                    userName: userData.sub,
                                    avatar: initials ?? "",
                                    userRole: LoggedUserRole,
                                    activeDirectoryLink: userData.userGuid,
                                    userEmail: userData.email,
                                    tenantId: userData.tenantId
                                };
                                this.isAutherized = true;
                                localStorage.setItem("UserDetails", JSON.stringify(this.userDetails))
                                this.userSubjectChanged.next(this.userDetails);
                            }


                            await this.requestService.validateJurisdiction(d.orgkey).then((res: Jurisdiction) => {
                                if (res) {
                                    localStorage.setItem("date-format", res.dateFormat)
                                    if (sessionStorage.getItem("matterId") != null) {
                                        this.commonService.appConfig!.redirectUri = `${this.commonService.appConfig?.redirectUri}/${sessionStorage.getItem("matterId")}`;
                                        }
                                    window.location.href = this.commonService.appConfig!.redirectUri
                                    resolve({ success: true, token: d.access_token, message: undefined });
                                }
                                else {
                                    localStorage.clear();
                                    this.userDetails = undefined;
                                    resolve({ success: false, token: undefined, message: "unsupported" })
                                }
                            })
                        })
                        .catch((e) => {
                            resolve({ success: false, token: undefined, message: e?.error?.errors?.length > 0 ? e?.error?.errors[0].message : "Error occured while processing the request." })
                        });
                }
                else {
                    window.location.href = this.actionStepAuthorizeUrl
                }
            });
    }

    async refreshToken(email?: string): Promise<AuthResponse> {
        return new Promise((resolve, reject) => {
            let loginUrl = `api/users/auth-user`
            this.dataService.post<string>(loginUrl, {
                userEmail: "",
                authCode: "",
                redirectUrl: this.commonService.appConfig?.redirectUri ?? "",
                grantType: "refresh_token",
                refreshToken: this.commonService.decrypt(localStorage.getItem("refresh-token")!) ?? "",
            })
                .then((d: any) => {
                    localStorage.setItem("tenantId", this.commonService.encrypt(d.orgkey));
                    localStorage.setItem("refresh-token", this.commonService.encrypt(d.refresh_token));
                    localStorage.removeItem("token");
                    localStorage.setItem("token", this.commonService.encrypt(d.access_token!));
                    resolve({ success: true, token: d.access_token, message: undefined });
                })
                .catch((e) => {
                    resolve({ success: false, token: undefined, message: e?.error?.errors?.length > 0 ? e?.error?.errors[0].message : "Error occured while processing the request." })
                });
        });
    }
}
